import { NgModule } from '@angular/core';
import { FdeGatewaySharedLibsModule } from './shared-libs.module';
import { AlertComponent } from './alert/alert.component';
import { AlertErrorComponent } from './alert/alert-error.component';
import { ItemCountComponent } from './pagination/item-count.component';
import { SortByDirective } from './pagination/sort-by.directive';
import { SortDirective } from './pagination/sort.directive';

@NgModule({
    imports: [FdeGatewaySharedLibsModule, AlertComponent, AlertErrorComponent, ItemCountComponent, SortDirective, SortByDirective],
    exports: [FdeGatewaySharedLibsModule, AlertComponent, AlertErrorComponent, ItemCountComponent, SortDirective, SortByDirective]
})
export class FdeGatewaySharedCommonModule {}
